<button mat-icon-button color="primary" (click)="toggleFlyout()">
	<mat-icon>account_tree</mat-icon>Related Vendors
</button>
<div *ngIf="!vendorInfo.isParent">
	Parent Vendor<br />
	<strong *ngIf="vendorInfo.parentName">{{vendorInfo.parentName}}</strong>
	<em *ngIf="!vendorInfo.parentName">None Selected</em>
</div>
<div *ngIf="vendorInfo.isParent">
	This Vendor is a Parent
</div>
<ng-template cdk-portal>
	<div class="linq-drawer-content related-vendors">
		<header class="linq-drawer-header">
			<h3 class="linq-heading">Related Vendors</h3>
			<button class="linq-drawer-header__close linq-button-close-lg" (click)="close()">
				<mat-icon>clear</mat-icon>
			</button>
		</header>
		<div class="linq-drawer-inner-content linq-drawer-inner-content--spaced flyout-inner-container">
			<form #relatedVendorsForm="ngForm">
				<label for="relationshipType">Relationship Type</label>
				<mat-radio-group aria-label="Select an option" [(ngModel)]="relationshipType" (change)="onRelationshipTypeChange()"
					name="relationshipTypeCtrl" #relationshipTypeCtrl="ngModel" class="stacked-radios" [disabled]="isReadOnly">
					<mat-radio-button color="primary" value="">None</mat-radio-button>
					<mat-radio-button color="primary" value="Child">Child Vendor</mat-radio-button>
					<mat-radio-button color="primary" value="Parent">Parent Vendor</mat-radio-button>
				</mat-radio-group>
				<ng-container *ngIf="relationshipType === 'Child'">
					<mat-form-field>
						<mat-label>Parent Vendor</mat-label>
						<input type="text" matInput [matAutocomplete]="auto" [(ngModel)]="model.parentName" name="parentVendor"
							#parentVendor="ngModel" maxlength="50" requiredNoWhitespace [disabled]="isReadOnly" (blur)="onParentVendorBlur()" />
						<button type="button" mat-icon-button matSuffix (click)="onParentVendorChanged(null)">
							<mat-icon>close</mat-icon>
						</button>
						<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onParentVendorChanged($event.option)">
							<mat-option *ngFor="let vendor of filteredParentVendors | async; trackById"
								[value]="vendor.ShortName + ' - ' + vendor.VendorName" [id]="vendor.Id">
								{{vendor.ShortName}} - {{vendor.VendorName}}
							</mat-option>
						</mat-autocomplete>
						<mat-error *ngIf="parentVendor.errors?.required">Parent Vendor is required</mat-error>
					</mat-form-field>
					<mat-slide-toggle class="linq-slide-toggle" color="primary" [(ngModel)]="model.parentNameOnCheck" name="parentNameOnCheck"
						#parentNameOnCheck="ngModel" [disabled]="isReadOnly">
						Use Parent Vendor Name on Checks
					</mat-slide-toggle>
					<h3 class="linq-heading">Sibling Vendors</h3>
					<table mat-table [dataSource]="this.siblings" class="flyout-table">
						<ng-container matColumnDef="name">
							<td mat-cell *matCellDef="let row" [class]="{disabled: !row.Active}" matTooltipPosition="above"
								[matTooltip]="row.Active ? '' : 'Vendor is disabled'">
								{{row.ShortName}} - {{row.Name}}
							</td>
						</ng-container>
						<tr mat-row *matRowDef="let row; columns: ['name'];"></tr>
						<tr class="mat-row no-data" *matNoDataRow>
							<td class="mat-cell" colspan="9999">None yet</td>
						</tr>
					</table>
				</ng-container>
				<ng-container *ngIf="relationshipType === 'Parent'">
					<h3 class="linq-heading">Child Vendors</h3>
					<mat-form-field>
						<input type="text" matInput [matAutocomplete]="auto" [ngModel] name="childVendor" #childVendor="ngModel" maxlength="50"
							placeholder="Add a Child Vendor" [disabled]="isReadOnly" />
						<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onChildVendorSelected($event.option.value)">
							<mat-option *ngFor="let vendor of filteredChildVendors | async; trackById" [value]="vendor">
								{{vendor.ShortName}} - {{vendor.VendorName}}
							</mat-option>
						</mat-autocomplete>
					</mat-form-field>
					<table mat-table [dataSource]="this.childrenDataSource" class="flyout-table">
						<ng-container matColumnDef="name">
							<td mat-cell *matCellDef="let row">
								<div [class]="{disabled: !row.Active}" matTooltipPosition="above"
									[matTooltip]="row.Active ? '' : 'Vendor is disabled'">{{row.ShortName}} - {{row.Name}}</div>
								<mat-slide-toggle class="linq-slide-toggle" color="primary" [checked]="row.ParentNameOnCheck"
									(change)="onParentNameOnCheckToggle(row)" name="childParentNameOnCheck" [disabled]="isReadOnly">
									Use Parent Vendor Name on Checks
								</mat-slide-toggle>
							</td>
						</ng-container>
						<ng-container matColumnDef="remove">
							<td mat-cell *matCellDef="let row">
								<button type="button" mat-icon-button title="Remove relationship" (click)="removeChildVendor(row.Id)"
									[disabled]="isReadOnly">
									<mat-icon>close</mat-icon>
								</button>
							</td>
						</ng-container>
						<tr mat-row *matRowDef="let row; columns: ['name', 'remove'];"></tr>
						<tr class="mat-row no-data" *matNoDataRow>
							<td class="mat-cell" colspan="9999">None yet</td>
						</tr>
					</table>
				</ng-container>
			</form>
		</div>
		<footer class="linq-drawer-footer">
			<button type="button" mat-stroked-button class="linq-button--secondary" (click)="close()">Cancel</button>
			<button type="button" mat-raised-button color="primary"
				[disabled]="!relatedVendorsForm.valid || isReadOnly || (relationshipType === 'Parent' && !this.childrenDataSource.data.length)"
				(click)="submit()">Save</button>
		</footer>
	</div>
</ng-template>
